import { FunctionComponent } from 'react';
import { View, Text, Card, Button } from '@upstox/upstox-ui';
import * as css from './RedherringCard.style';
import { DESCRIPTION_TEXT, BUTTON_TEXT } from './constants';

type Props = {
  redHerringProspectusUrl: string;
};
const RedherringCard: FunctionComponent<Props> = ({
  redHerringProspectusUrl,
}) => {
  return (
    <View css={css.redHerringCard}>
      <Card css={css.cardStyles}>
        <View flexDirection="column" css={css.cardContent}>
          <Text size="l" weight="heading2" color="background.upstoxLogo">
            Red herring prospectus
          </Text>
          <View css={css.descriptionText}>
            <Text
              variant="meta"
              color="text.default"
              size="m"
              lineHeight="body"
            >
              {DESCRIPTION_TEXT}
            </Text>
          </View>
          <View css={css.redherringButton}>
            <Button css={css.buttonStyles} disabled={!redHerringProspectusUrl}>
              <a
                target="_blank"
                href={redHerringProspectusUrl}
                rel="noreferrer"
              >
                <Text variant="metaBold" color="text.link" size="m">
                  {BUTTON_TEXT}
                </Text>
              </a>
            </Button>
          </View>
        </View>
      </Card>
    </View>
  );
};

export default RedherringCard;
